import $ from "jquery";
import {
  pergola,
  pergolaConst,
  theModel,
  toggleLoad,
} from "../../../core/3d-configurator";
import { state } from "../../../core/settings";
import {
  stringEndCuts,
  stringPostType,
  stringRoofType,
  stringTypeModel,
} from "../../Interface/interface";
import {
  stringNameFrameColor,
  stringNameRoofLetticeColor,
  stringNameRoofSolidColor,
  wallAddOptionString,
} from "../../Interface/interfaceItems/interfaceGroup/interfaceGroupInputs/interfaceGroupInputs";
// import { loadFormData } from "./summary-page-portal/summaryPagePortal";
import "./summaryPage.scss";
export let countLeds = {
  count: 0,
};

export function countVisibleObjectsByName(
  scene,
  name,
  exactMatch = false,
  checkChildrenVisible = false
) {
  let count = 0;

  scene.traverse((object) => {
    const isMatch = exactMatch
      ? object.name === name
      : object.name.includes(name);

    const isTargetType = object.isMesh || object.type === "Group";

    if (!isMatch || !isTargetType || !object.visible) return;

    if (checkChildrenVisible && object.children.length > 0) {
      const allChildrenVisible = object.children.every(
        (child) => child.visible
      );
      if (!allChildrenVisible) return;
    }

    count++;
  });

  return count;
}

export function countActiveHeatersInPergola() {
  const count = pergola.spanHeater.objects.filter((span) => span.isSystemSet);

  return count.length;
}

export function countActiveSystemsInPergola(typeSystem) {
  const count = pergola.span.objects
    .filter((span) => span.isSystemSet)
    .filter((span) =>
      span.systems.some((system) => system.active && system.type === typeSystem)
    );

  return count.length;
}

export function summaryPageComponent(container) {
  const modelType = stringTypeModel[state.type3Dmodel];
  const mounted =
    [
      state.backWall && "Back Wall",
      state.leftWall && "Left Wall",
      state.rightWall && "Right Wall",
    ]
      .filter(Boolean)
      .join(", ") || `${wallAddOptionString[state.wallOption]}`;

  // const roofType = stringRoofType[state.roofType];
  // const stringPostTypeNew = {
  //   0: state.wrapKit || state.roofType === 2 ? "Santa Fe" : "Classic",
  //   1: "Square Column",
  //   2: "Round Column",
  // };
  // const postType = stringPostTypeNew[state.postType];
  // const postSize = `${state.postSize}' x ${state.postSize}'`;
  // const endCuts = `${stringEndCuts[state.endCuts - 1]}`;

  const frameColor = state.colorBody;
  const roofColor = state.colorRoof;

  const ledLight = state.ledLights ? `${countLeds.count}` : "No";
  const brightness =
    state.colorLed === "#FAFFC4" ? "3500 lumens" : "2500 lumens";
  const frequency = `Every ${state.spacing} louvers`;
  const fans = state.fans ? `Yes` : "No";
  const heaters = state.heaters ? `Yes` : "No";

  // const isTexture =
  //   typeof state.colorBody === "string" &&
  //   /\.(jpe?g|png|webp)$/i.test(state.colorBody);

  const styleFrame = `background-color: ${
    state.colorBody.includes(".") ? "#9F602C" : state.colorBody
  }; background-size: cover; background-position: center;`;
  const styleRoofLettice = `background-color: ${
    state.colorRoof.includes(".") ? "#9F602C" : state.colorRoof
  }; background-size: cover; background-position: center;`;
  const styleRoofSolid = `background-color: ${state.colorRoofSolid}; background-size: cover; background-position: center;`;

  const summaryContent = $(`
    <div id="summary-content">
  <div class="sum__page" id="sum-page">
    <h2 class="sum__page__title">Summary</h2>
    <div class="sum__page__close" id="sum-close"></div>

    <div id="js-summary-image-preview-1">
      <img class="sum__page__img" />
    </div>

    <ul class="sum__page__main-list">

    <p class="sum__page__main-list__info__param">All measurments, design and placement are approximate and subject for approval uppon execution of order.</p>

      <li class="sum__page__main-list__item">
        <p class="sum__page__main-list__title">Model</p>

        <div class="sum__page__main-list__info"> 
          <h3 class="sum__page__main-list__info__title">Type</h3>
          <div class="sum__page__main-list__info__param">${modelType}</div>
        </div>
      </li>

     <li class="sum__page__main-list__item">
        <p class="sum__page__main-list__title">Mounted</p>

        <div class="sum__page__main-list__info"> 
          <div class="sum__page__main-list__info__title">
            Back Wall
          </div>

          <div class="sum__page__main-list__info__param">
            ${state.backWall ? "Yes" : "No"}
          </div>
        </div>

        <div class="sum__page__main-list__info">
          <div class="sum__page__main-list__info__title">
            Left Wall
          </div>
          <div class="sum__page__main-list__info__param">
            ${state.leftWall ? "Yes" : "No"}
          </div>
        </div>

        <div class="sum__page__main-list__info">
          <div class="sum__page__main-list__info__title">
            Right Wall
          </div>
          <div class="sum__page__main-list__info__param">
            ${state.rightWall ? "Yes" : "No"}
          </div>
        </div>
      </li>


    <li class="sum__page__main-list__item">
        <p class="sum__page__main-list__title">Dimensions</p>

        <div class="sum__page__main-list__info"> 
          <h3 class="sum__page__main-list__info__title">Width</h3>
          <div class="sum__page__main-list__info__param">${state.width.toFixed(2)}'</div>
        </div>

        <div class="sum__page__main-list__info"> 
          <h3 class="sum__page__main-list__info__title">Length</h3>
          <div class="sum__page__main-list__info__param">${state.length.toFixed(2)}'</div>
        </div>

        <div class="sum__page__main-list__info"> 
          <h3 class="sum__page__main-list__info__title">Height</h3>
          <div class="sum__page__main-list__info__param">${state.height.toFixed(2)}'</div>
        </div>
      </li>

      <li class="sum__page__main-list__item">
        <p class="sum__page__main-list__title">Frame color</p>

       
        <div class="sum__page__main-list__info"> 
          <div class="sum__page__main-list__info__color" style="${styleFrame}"></div>
          <div class="sum__page__main-list__info__param">${
            state.selectedFrameColorName
          }</div>
        </div>

         ${
           !state.type3Dmodel
             ? `<div class="sum__page__main-list__info" style="margin-top: 15px"> 
          <h3 class="sum__page__main-list__info__title">Remove gold bar</h3>
          <div class="sum__page__main-list__info__param">${
            state.goldBar ? "Yes" : "No"
          }</div>
        </div>`
             : ""
         }          
      </li>

      <li class="sum__page__main-list__item">
        <p class="sum__page__main-list__title">Roof color</p>

       ${
         state.roofType === 0 || state.roofType === 2
           ? `<div class="sum__page__main-list__info">
             <div
               class="sum__page__main-list__info__color"
               style="${styleRoofLettice}"
             ></div>
             <div class="sum__page__main-list__info__param">
               ${state.selectedRoofColorName}
             </div>
           </div>`
           : ""
       } 
        
       ${
         state.roofType === 1 || state.roofType === 2
           ? `<div class="sum__page__main-list__info">
             <div
               class="sum__page__main-list__info__color"
               style="${styleRoofSolid}"
             ></div>
             <div class="sum__page__main-list__info__param">
              ${state.selectedRoofColorName}
             </div>
           </div>`
           : ""
       }
      </li>

          <li class="sum__page__main-list__item">
        <p class="sum__page__main-list__title">Accessories</p>

        <div class="sum__page__main-list__info"> 
          <h3 class="sum__page__main-list__info__title">${
            pergolaConst.systemNameString.sliding_doors
          }</h3>
          <div class="sum__page__main-list__info__param">${
            countActiveSystemsInPergola(
              pergolaConst.systemType.sliding_doors
            ) || "No"
          }</div>
        </div>

        <div class="sum__page__main-list__info"> 
          <h3 class="sum__page__main-list__info__title">${
            pergolaConst.systemNameString.sliding_shutters
          }</h3>
          <div class="sum__page__main-list__info__param">${
            countActiveSystemsInPergola(
              pergolaConst.systemType.sliding_shutters
            ) || "No"
          }</div>
        </div>

        <div class="sum__page__main-list__info"> 
          <h3 class="sum__page__main-list__info__title">${
            pergolaConst.systemNameString.zip_shade
          }</h3>
          <div class="sum__page__main-list__info__param">${
            countActiveSystemsInPergola(pergolaConst.systemType.zip_shade) ||
            "No"
          }</div>
        </div>

        <div class="sum__page__main-list__info"> 
          <h3 class="sum__page__main-list__info__title">${
            pergolaConst.systemNameString.railing_frame
          }</h3>
          <div class="sum__page__main-list__info__param">${
            countActiveSystemsInPergola(
              pergolaConst.systemType.railing_frame
            ) || "No"
          }</div>
        </div>
      </li>

      <li class="sum__page__main-list__item">
        <p class="sum__page__main-list__title">Extra Options</p>

        <div class="sum__page__main-list__info"> 
          <h3 class="sum__page__main-list__info__title">${
            pergolaConst.optionNameString.LEDRampLight
          }</h3>
          <div class="sum__page__main-list__info__param">${
            state.electro.has(pergolaConst.optionNameString.LEDRampLight)
              ? "Yes"
              : "No"
          }</div>
        </div>

        <div class="sum__page__main-list__info"> 
          <h3 class="sum__page__main-list__info__title">${
            pergolaConst.optionNameString.fans
          }</h3>
          <div class="sum__page__main-list__info__param">${
            state.electro.has(pergolaConst.optionNameString.fans) ? "Yes" : "No"
          }</div>
        </div>

         <div class="sum__page__main-list__info"> 
          <h3 class="sum__page__main-list__info__title">${
            pergolaConst.optionNameString.heaters
          }</h3>
          <div class="sum__page__main-list__info__param">${
            countActiveHeatersInPergola() || "No"
          }</div>
        </div>

        ${
          state.type3Dmodel
            ? ` <div class="sum__page__main-list__info"> 
          <h3 class="sum__page__main-list__info__title">${
            pergolaConst.optionNameString.ledLouvers
          }</h3>
          <div class="sum__page__main-list__info__param">${
            state.electro.has(pergolaConst.optionNameString.ledLouvers)
              ? "Yes"
              : "No"
          }</div>
        </div>`
            : ""
        }
       
      </li>
    </ul>
  
    <div class="sum__page__buttons">
      <button class="sum__page__buttons__button sum__page__buttons__button--back" id="back-bt">Back</button>
      <button class="sum__page__buttons__button sum__page__buttons__button--contact" id="contact-bt">Request Quote and Download PDF</button>
    </div>
  </div>
</div>
    `);

  const backButton = summaryContent.find("#back-bt");
  const contactButton = summaryContent.find("#contact-bt");
  const downloadButton = summaryContent.find("#dw-bt");

  summaryContent.find("#sum-close").on("click", () => {
    $("html, body").animate({ scrollTop: 0 }, "fast", () => {
      summaryContent.hide();
      $("body").removeClass("body-overflow-auto");
    });
  });

  backButton.on("click", () => {
    toggleLoad(true);
    $("html, body").animate({ scrollTop: 0 }, "fast", () => {
      summaryContent.hide();
      $("body").removeClass("body-overflow-auto");
    });
    toggleLoad(false);
  });

  contactButton.on("click", () => {
    // loadFormData(".form-container");

    $("#sum-portal-with-comment").show();

    $("body").removeClass("body-overflow-auto");
  });

  downloadButton.on("click", async () => {
    toggleLoad(true);
    //OPEN FORM
    $("#sum-portal").show();

    $("body").removeClass("body-overflow-auto");

    // await createPDF();
    toggleLoad(false);
  });

  $(container).append(summaryContent);
}
